import { createReducer } from "redux-act";

import * as a from "../actions/facilitatorApplication";

const getDefaultState = () => ({
  isLoadingApplicationToFacilitate: false,
  isAppliedToFacilitate: false,
  latestApplicationEmployer: null,
  isLoadingApplication: false,
  corporatePartners: null,
  isLoadingCorporatePartners: false,
});

export default () =>
  createReducer(
    {
      [a.applyToFacilitate]: (state) => {
        return {
          ...state,
          isLoadingApplicationToFacilitate: true,
        };
      },
      [a.receivedResponseOnApplyToFacilitate]: (state, status) => {
        return {
          ...state,
          isAppliedToFacilitate: status,
          isLoadingApplicationToFacilitate: false,
      }},
      [a.cleanApplyToFacilitate]: (state) => {
        return {
          ...state,
          isAppliedToFacilitate: false,
      }},
      [a.getLatestApplicationEmployer]: (state) => {
        return {
          ...state,
          isLoadingApplication: true,
        };
      },
      [a.receivedLatestApplicationEmployer]: (state, payload) => {
        const { employerName } = payload;
        return {
          ...state,
          latestApplicationEmployer: employerName,
          isLoadingApplication: false,
        };
      },
      [a.getLatestApplicationEmployerError]: (state) => {
        return {
          ...state,
          isLoadingApplication: false,
        };
      },
      [a.getCorporatePartnersList]: (state) => {
        return {
          ...state,
          isLoadingCorporatePartners: true,
        };
      },
      [a.receivedCorporatePartnersList]: (state, payload) => {
        const { corporatePartnersList } = payload;
        return {
          ...state,
          corporatePartners: corporatePartnersList,
          isLoadingCorporatePartners: false,
        };
      },
      [a.getCorporatePartnersListError]: (state) => {
        return {
          ...state,
          isLoadingCorporatePartners: false,
        };
      },
    },
    getDefaultState()
  );
